import _typeof from './typeof'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toPrimitive = (t: any, r: any): any => {
  if ('object' !== _typeof(t) || !t) return t
  const e = t[Symbol.toPrimitive]
  if (e !== undefined) {
    const i = e.call(t, r || 'default')
    if ('object' != _typeof(i)) return i
    throw new TypeError('@@toPrimitive must return a primitive value.')
  }
  return ('string' === r ? String : Number)(t)
}

export default toPrimitive
